"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.ContactSubCategory = (0, type_utils_1.makeEnum)({
    /** An email address */
    Email: 'EMAIL',
    /** A phone number */
    Phone: 'PHONE',
    /** Fallback subcategory */
    Contact: 'CONTACT',
});
//# sourceMappingURL=contact.js.map